import { DTOModel } from "../base/dto-model";
import { CompanyAccountRef } from "../company-accounts/company-accounts/company-account-ref";

export class AtCompanyAccountDTO extends DTOModel {
  companyAccount: CompanyAccountRef | null = null;
}
